const OrderGateway = () =>
  import(
    /* webpackChunkName: "system-gateway-order" */ '@/pages/system/gateway/order/index.vue'
  )
const CreateOrderGateway = () =>
  import(
    /* webpackChunkName: "system-gateway-order" */ '@/pages/system/gateway/order/create.vue'
  )
const EditOrderGateway = () =>
  import(
    /* webpackChunkName: "system-gateway-order" */ '@/pages/system/gateway/order/edit.vue'
  )

export default {
  path: 'order',
  meta: {
    label: 'shipment',
    auth: 'order'
  },
  component: {
    name: 'Order',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: '',
      name: 'SystemGatewayOrder',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: OrderGateway
    },
    {
      name: 'SystemCreateGatewayOrder',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateOrderGateway
    },
    {
      name: 'SystemEditGatewayOrder',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditOrderGateway,
      props: true
    }
  ]
}
